import script from "./GiaThanhSuaChuaCacCapPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiaThanhSuaChuaCacCapPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./GiaThanhSuaChuaCacCapPrintModal.vue?vue&type=style&index=0&id=3a977de0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a977de0"]])

export default __exports__